export default {
    type: 'set',
    format: {
        searchOnly: true
    },
    default: {
        logic: 'match',
        tolerance: 2,
        operand: '>=',
        value: []
    },
    setting: {
        logic: ['match', 'oneof', 'someof', 'allof']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Families',
        category: 'Game',
        description: 'Groupings or series the game belongs to.',
        summarise: {
            prefix: 'Game family'
        },
        unit: 'family'
    },
    rules: {
        linked: [],
        legacy: ['families']
    }
}